// GETTERS
export const GET_PUBLISHER_BY_ID = 'GET_PUBLISHER_BY_ID';
export const GET_TEMPLATE_BY_ID = 'GET_TEMPLATE_BY_ID';
export const GET_TEMPLATE_BY_CREATIVE_ID = 'GET_TEMPLATE_BY_CREATIVE_ID';
export const GET_REGION_BY_ID = 'GET_REGION_BY_ID';
export const GET_COUNTRY_BY_ID = 'GET_COUNTRY_BY_ID';
export const GET_ALL_COMBINATIONS = 'GET_ALL_COMBINATIONS';
export const GET_PARSED_FILE_RESULT_WITH_COMBINATIONS = 'GET_PARSED_FILE_RESULT_WITH_COMBINATIONS';
export const GET_COUNTRYS_BY_IDS = 'GET_COUNTRYS_BY_IDS';
export const GET_GEOS_BY_IDS = 'GET_GEOS_BY_IDS';
export const GET_GROUPED_TRACKERS_LIST = 'GET_GROUPED_TRACKERS_LIST';

// ACTIONS
export const RESET_IMPORT_TRACKERS = 'RESET_IMPORT_TRACKERS';
export const FETCH_TRACKERS = 'FETCH_TRACKERS';
export const FETCH_SELF_SERVICE_CONTENT_TRACKERS = 'FETCH_SELF_SERVICE_CONTENT_TRACKERS';
export const FETCH_SELF_SERVICE_CONTENT_TRACKERS_MULTIPLE_CREATIVE = 'FETCH_SELF_SERVICE_CONTENT_TRACKERS_MULTIPLE_CREATIVE';
export const GET_TRACKERS_CSV = 'GET_TRACKERS_CSV';
export const DELETE_TRACKERS = 'DELETE_TRACKERS';
export const GET_TRACKERS_VALIDATION = 'GET_TRACKERS_VALIDATION';
export const PUT_TRACKERS_REVALIDATION = 'PUT_TRACKERS_REVALIDATION';
export const PARSE_TRACKERS_FILE = 'PARSE_TRACKERS_FILE';
export const POLL_TRACKER_VALIDATION = 'POLL_TRACKER_VALIDATION';
export const ADD_SELF_SERVICE_TRACKERS = 'ADD_SELF_SERVICE_TRACKERS';
export const SAVE_SELF_SERVICE_CONTENT_TRACKERS = 'SAVE_SELF_SERVICE_CONTENT_TRACKERS';

export const ADD_GROUPED_TRACKERS_LIST = 'ADD_GROUPED_TRACKERS_LIST';
export const DELETE_GROUP_FROM_GROUPED_LIST = 'DELETE_GROUP_FROM_GROUPED_LIST';
export const UPDATE_ITEM_IN_GROUPED_LIST = 'UPDATE_ITEM_IN_GROUPED_LIST';
export const DELETE_ITEM_FROM_GROUPED_LIST = 'DELETE_ITEM_FROM_GROUPED_LIST';
export const ADD_TRACKER_TO_GROUPED_LIST_ITEM = 'ADD_TRACKER_TO_GROUPED_LIST_ITEM';
export const MANUALLY_ENTER_TRACKERS = 'MANUALLY_ENTER_TRACKERS';
export const MANUALLY_UPDATE_TRACKER = 'MANUALLY_UPDATE_TRACKER';
export const DELETE_TRACKER_FROM_GROUPED_LIST_ITEM = 'DELETE_TRACKER_FROM_GROUPED_LIST_ITEM';
// ACTIONS Tracker Validation
export const CREATE_TRACKERS_FOR_VALIDATION = 'CREATE_TRACKERS_FOR_VALIDATION';
export const UPDATE_TRACKERS_FOR_VALIDATION = 'UPDATE_TRACKERS_FOR_VALIDATION';
export const UPDATE_TRACKERS_FOR_VALIDATION_BY_ITEM = 'UPDATE_TRACKERS_FOR_VALIDATION_BY_ITEM';
export const UPDATE_TRACKERS_FOR_VALIDATION_REFERENCE_COLUMN = 'UPDATE_TRACKERS_FOR_VALIDATION_REFERENCE_COLUMN';
export const SAVE_TRACKERS = 'SAVE_TRACKERS';
export const DELETE_TRACKER_VALIDATION_RESULTS = 'DELETE_TRACKER_VALIDATION_RESULTS';

// MUTATIONS
export const SET_CAMPAIGN_TRACKERS = 'SET_CAMPAIGN_TRACKERS';
export const SET_PARSED_FILE_RESULT = 'SET_PARSED_FILE_RESULT';
export const SET_COMBINATION_SPLIT = 'SET_COMBINATION_SPLIT';
export const SET_COLUMNS_TO_DISPLAY = 'SET_COLUMNS_TO_DISPLAY';
export const SET_TRACKERS_HEALTH_STATUS_DATA = 'SET_TRACKERS_HEALTH_STATUS_DATA';
export const REMOVE_TRACKER = 'REMOVE_TRACKER';
export const UPDATE_TRACKER_COMBINATION = 'UPDATE_TRACKER_COMBINATION';
export const SET_TRACKERS_FOR_VALIDATION = 'SET_TRACKERS_FOR_VALIDATION';
export const UPDATE_TRACKERS_SELECTED_COMBINATIONS = 'UPDATE_TRACKERS_SELECTED_COMBINATIONS';
export const SET_SELF_SERVICE_TRACKERS = 'SET_SELF_SERVICE_TRACKERS';
export const SET_GROUPED_TRACKERS_LIST = 'SET_GROUPED_TRACKERS_LIST';
export const REMOVE_GROUP_FROM_GROUPED_LIST = 'REMOVE_GROUP_FROM_GROUPED_LIST';
export const APPEND_ITEM_TO_GROUPED_LIST = 'APPEND_ITEM_TO_GROUPED_LIST';
export const CHANGE_ITEM_IN_GROUPED_LIST = 'CHANGE_ITEM_IN_GROUPED_LIST';
export const REMOVE_ITEM_FROM_GROUPED_LIST = 'REMOVE_ITEM_FROM_GROUPED_LIST';

// ACTIONS + MUTATIONS
export const SET_IMPORTING_PLACEMENT_LEVEL_TRACKERS = 'SET_IMPORTING_PLACEMENT_LEVEL_TRACKERS';
